var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41.5,
    height: 29,
    rx: 3.5,
    fill: "white",
    stroke: "#B2BCCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4378 19.8228H10.8631L8.93244 12.2404C8.84081 11.8916 8.64623 11.5833 8.36002 11.4379C7.64573 11.0727 6.85864 10.7821 6 10.6355V10.3436H10.1476C10.72 10.3436 11.1494 10.7821 11.2209 11.2914L12.2227 16.7607L14.7961 10.3436H17.2992L13.4378 19.8228ZM18.7303 19.8228H16.2988L18.301 10.3436H20.7326L18.7303 19.8228ZM23.8784 12.9696C23.95 12.4591 24.3793 12.1672 24.8802 12.1672C25.6672 12.0939 26.5246 12.2405 27.2402 12.6044L27.6695 10.5635C26.954 10.2716 26.1669 10.125 25.4526 10.125C23.0926 10.125 21.3753 11.438 21.3753 13.2603C21.3753 14.6466 22.5917 15.3745 23.4503 15.813C24.3793 16.2503 24.737 16.5422 24.6655 16.9794C24.6655 17.6353 23.95 17.9272 23.2357 17.9272C22.377 17.9272 21.5184 17.7086 20.7326 17.3434L20.3032 19.3856C21.1619 19.7495 22.0908 19.8961 22.9495 19.8961C25.5957 19.9681 27.2402 18.6564 27.2402 16.6875C27.2402 14.2081 23.8784 14.0627 23.8784 12.9696ZM35.7499 19.8228L33.8192 10.3436H31.7454C31.3161 10.3436 30.8868 10.6355 30.7437 11.0727L27.1685 19.8228H29.6716L30.1712 18.4377H33.2468L33.533 19.8228H35.7499ZM32.1033 12.8962L32.8176 16.4688H30.8154L32.1033 12.8962Z",
    fill: "#28356A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLight);
export default __webpack_public_path__ + "static/media/visa_light.5fca7da3ac4d7055db54e65fe9f66ff3.svg";
export { ForwardRef as ReactComponent };